import { render, staticRenderFns } from "./addCdkey.vue?vue&type=template&id=41a588cc&scoped=true"
import script from "./addCdkey.vue?vue&type=script&lang=js"
export * from "./addCdkey.vue?vue&type=script&lang=js"
import style0 from "./addCdkey.vue?vue&type=style&index=0&id=41a588cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a588cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a588cc')) {
      api.createRecord('41a588cc', component.options)
    } else {
      api.reload('41a588cc', component.options)
    }
    module.hot.accept("./addCdkey.vue?vue&type=template&id=41a588cc&scoped=true", function () {
      api.rerender('41a588cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/addCdkey.vue"
export default component.exports